export interface ICadenceImpressionFeasibilityAPI {
  max_cadence: string;
  ceil_cadence: string;
  optimized_cadence: string;
  floor_cadence: string;
}

export default class CadenceImpressionFeasibility {
  floorCadence?: string;

  optimizedCadence?: string;

  ceilCadence?: string;

  maxCadence?: string;

  apiObject?: ICadenceImpressionFeasibilityAPI;

  constructor(floorCadence?: string, optimizedCadence?: string, ceilCadence?: string, maxCadence?: string) {
    this.floorCadence = floorCadence;
    this.optimizedCadence = optimizedCadence;
    this.ceilCadence = ceilCadence;
    this.maxCadence = maxCadence;
    this.apiObject = null;
  }

  static fromApi(apiObject: ICadenceImpressionFeasibilityAPI): CadenceImpressionFeasibility {
    if (apiObject !== undefined) {
      const cadenceImpressionFeasibility = new CadenceImpressionFeasibility(
        apiObject.floor_cadence,
        apiObject.optimized_cadence,
        apiObject.ceil_cadence,
        apiObject.max_cadence,
      );
      cadenceImpressionFeasibility.apiObject = apiObject;
      return cadenceImpressionFeasibility;
    }
    return new CadenceImpressionFeasibility();
  }
}
